import React, { useState } from 'react';
import { Input } from '../../../_shared/components/Input/Input';
import { ReactComponent as SearchIcon } from '../../../_shared/assets/icons/searchIcon.svg';
import { Select } from '../../../_shared/components/Select/Select';
import { Button } from '../../../_shared/components/Button/Button';
import { mockKpiFactsTables } from '../../../_shared/mocks';
import { KpiItem } from '../../../_shared/types';
import { CardData } from '../../components/CardData/CardData';
import styles from './EstimateFactsView.module.scss';

const INPUT = ['Только ручного ввода', 'Только автоматического ввода'];
const SORT_OPTIONS = ['Сначала новые', 'Сначала старые'];

export function EstimateFactsView() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedInput, setSelectedInput] = useState<string>('');
  const [selectedSort, setSelectedSort] = useState<string>('');
  const [selectedKpi, setSelectedKpi] = useState<KpiItem | null>(null);
  return (
    <>
      <form className={styles.form}>
        <div className={styles.searchWrapper}>
          <Input
            label="Поиск по ФИО и названию КПЭ"
            name="search"
            type="text"
            value={searchQuery}
            variant={'grey'}
            onChange={(e) => setSearchQuery(e.target.value)}
            className={styles.searchInput}
          />
          <SearchIcon className={styles.searchIcon} />
        </div>
        <div className={styles.selectors}>
          <div className={styles.filters}>
            <Select
              label="Подразделения"
              options={INPUT}
              value={selectedInput}
              onChange={(value) => setSelectedInput(value ?? '')}
            />
          </div>
          <div className={styles.filters}>
            <Select
              label="Сначала новые"
              options={SORT_OPTIONS}
              value={selectedSort}
              onChange={(value) => setSelectedSort(value ?? '')}
            />
          </div>
        </div>
      </form>
      <div className={styles.buttons}>
        <Button
          variant="blue"
          onClick={() => {}}
          size={'small'}
          className={styles.button}
        >
          Все
        </Button>
        <Button
          variant="gray"
          onClick={() => {}}
          size={'small'}
          className={styles.button}
        >
          Незаполненные
        </Button>
        <Button
          variant="gray"
          onClick={() => {}}
          size={'small'}
          className={styles.button}
        >
          Заполненные
        </Button>
      </div>
      <CardData content={mockKpiFactsTables} />
    </>
  );
}
